import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as integratorWebhookLogApi from "@rentiohq/shared-frontend/dist/reduxV2/integratorWebhookLog/integratorWebhookLog.api";
import { formatDateAndTime } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getMessageForError } from "@rentiohq/shared-frontend/dist/utils/error.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { Banner } from "../Banner";
import { Loading } from "../Loading";
import { Lozenge } from "../Lozenge";
import { Modal } from "../Modal";
import { Stack } from "../Stack";
import { TextStyle } from "../TextStyle";
import * as S from "./IntegratorWebhookLogs.styled";
import { formatBodyForDisplay, getResendReasonLabelKey, getResendStatusAppearance, getWebhookTypeLabel, } from "./IntegratorWebhookLogs.utils";
var EMPTY_VALUE = "—";
var Section = function (props) { return (_jsxs(Stack, { vertical: true, spacing: "extraTight", children: [_jsx(TextStyle, { variation: "strong", children: props.title }), props.children] })); };
var Body = function (props) {
    var formatted = formatBodyForDisplay(props.value);
    if (!formatted) {
        return (_jsx(TextStyle, { variation: "subdued", children: getLocalizedText("integrator_webhook_log.detail.empty") }));
    }
    return _jsx(S.Code, { children: formatted });
};
export var IntegratorWebhookLogDetailModal = function (props) {
    var logId = props.logId, brokerId = props.brokerId, resendResult = props.resendResult, isResending = props.isResending, onResend = props.onResend, onClose = props.onClose;
    var _a = React.useState(), log = _a[0], setLog = _a[1];
    var _b = React.useState(), fetchError = _b[0], setFetchError = _b[1];
    React.useEffect(function () {
        var isCancelled = false;
        setLog(undefined);
        setFetchError(undefined);
        integratorWebhookLogApi
            .getDetail({ id: logId, brokerId: brokerId })
            .then(function (result) {
            if (!isCancelled) {
                setLog(result);
            }
        })
            .catch(function (error) {
            if (!isCancelled) {
                setFetchError(error);
            }
        });
        return function () {
            isCancelled = true;
        };
    }, [logId, brokerId]);
    var renderContent = function () {
        var _a;
        if (fetchError) {
            return (_jsx(Banner, { title: getMessageForError(fetchError), variation: "error", hasDismiss: false }));
        }
        if (!log) {
            return _jsx(Loading, { asDots: true });
        }
        var blockedReasonKey = getResendReasonLabelKey(log.resendBlockedReason);
        var resendReasonKey = getResendReasonLabelKey(resendResult === null || resendResult === void 0 ? void 0 : resendResult.reason);
        return (_jsxs(Stack, { vertical: true, spacing: "loose", children: [_jsx(Section, { title: getLocalizedText("integrator_webhook_log.detail.url"), children: _jsx(S.Code, { children: "".concat(log.method, " ").concat(log.url) }) }), _jsx(Section, { title: getLocalizedText("integrator_webhook_log.heading.date"), children: log.createdAt ? formatDateAndTime(log.createdAt) : EMPTY_VALUE }), _jsx(Section, { title: getLocalizedText("integrator_webhook_log.heading.webhook_type"), children: getWebhookTypeLabel(log.effectiveWebhookType) }), _jsx(Section, { title: getLocalizedText("integrator_webhook_log.heading.status_code"), children: (_a = log.responseStatus) !== null && _a !== void 0 ? _a : EMPTY_VALUE }), resendResult && (_jsx(Section, { title: getLocalizedText("integrator_webhook_log.heading.resend_result"), children: _jsxs(Stack, { vertical: true, spacing: "extraTight", children: [_jsx(Lozenge, { appearance: getResendStatusAppearance(resendResult.status), children: getLocalizedText("integrator_webhook_log.resend.status.".concat(resendResult.status.toLowerCase())) }), resendResult.reason && (_jsx(TextStyle, { variation: "subdued", size: "small", children: resendReasonKey
                                    ? getLocalizedText(resendReasonKey)
                                    : resendResult.reason }))] }) })), log.resendBlockedReason && (_jsx(Section, { title: getLocalizedText("integrator_webhook_log.detail.resend_blocked"), children: blockedReasonKey
                        ? getLocalizedText(blockedReasonKey)
                        : log.resendBlockedReason })), _jsx(Section, { title: getLocalizedText("integrator_webhook_log.detail.error"), children: _jsx(Body, { value: log.errorMessage }) }), _jsx(Section, { title: getLocalizedText("integrator_webhook_log.detail.request_body"), children: _jsx(Body, { value: log.requestBody }) }), _jsx(Section, { title: getLocalizedText("integrator_webhook_log.detail.response_body"), children: _jsx(Body, { value: log.responseBody }) })] }));
    };
    return (_jsx(Modal, { width: "large", heading: getLocalizedText("integrator_webhook_log.detail.title", {
            id: "".concat(logId),
        }), onClose: onClose, shouldCloseOnOverlayClick: true, hasDismiss: true, actions: [
            {
                content: getLocalizedText("integrator_webhook_log.cta.resend"),
                appearance: "primary",
                onClick: onResend,
                // Refused rows say why in the body; until the row is loaded nothing is known yet.
                isDisabled: !log || !!log.resendBlockedReason || isResending,
                isSubmitting: isResending,
            },
        ], children: renderContent() }));
};
